/**
 * Created by Rodrigo Quesada on 14/03/17.
 */
import {Component, HostListener, ViewChild} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';
import {BehaviorSubject} from 'rxjs';
import {NavigationService} from '../../../../navigation/service/navigation.service';
import {ModalComponent, ModalComponentBase} from '../../../../common/modal/modal-component.class';

//region Other Classes
class DisplayState {
    readonly editMode: boolean = false;
    readonly showEditButton: boolean = false;
    readonly showSaveButton: boolean = false;
    readonly showCancelEditButton: boolean = false;
}

class ViewState extends DisplayState {
    showEditButton = true;
}

class EditState extends DisplayState {
    editMode = true;
    showSaveButton = true;
    showCancelEditButton = true;
}

class EditOnlyState extends EditState {
    showCancelEditButton = false;
}

//endregion

const State = {VIEW: new ViewState(), EDIT: new EditState(), EDIT_ONLY: new EditOnlyState()};

@Component({
    selector: 'my-signature-modal-input',
    template: require('./signature-modal.component.html'),
    styles: [require('./signature-modal.component.scss')]
})
export class SignatureModalComponent extends ModalComponent(ModalComponentBase) {

    screenPadding = 10 + 15 + 2 + 2 + 15 + 10;

    signaturePadMaxWidth = 500;
    signaturePadMaxHeight = 300;
    signaturePadSizeRatio = this.signaturePadMaxWidth / this.signaturePadMaxHeight;

    signaturePadOptions = {
        canvasWidth: this.signaturePadMaxWidth,
        canvasHeight: this.signaturePadMaxHeight
    };

    signaturePadWidth = this.signaturePadOptions.canvasWidth;
    signaturePadHeight = this.signaturePadOptions.canvasHeight;

    private _signaturePad: SignaturePad;
    @ViewChild(SignaturePad)
    set signaturePad(value: SignaturePad) {
        this._signaturePad = value;
        this.resizeSignaturePad();
    }

    //region HostListeners
    @HostListener('window:resize', ['$event'])
    onResize(event) { this.resizeSignaturePad(); }

    //endregion

    data$ = new BehaviorSubject<string | undefined>(undefined);

    set data(value: string) { this.data$.next(value); }

    display: DisplayState = State.EDIT;

    constructor(readonly modal: NgbActiveModal, navigationService: NavigationService) {
        super(navigationService);

        this.data$.subscribe(data => this.display = data ? State.VIEW : State.EDIT_ONLY);
    }

    resizeSignaturePad() {
        this.signaturePadWidth = Math.min(window.innerWidth - this.screenPadding, this.signaturePadMaxWidth);
        this.signaturePadHeight = this.signaturePadWidth / this.signaturePadSizeRatio;
        if (this._signaturePad) {
            this._signaturePad.set('canvasWidth', this.signaturePadWidth);
            this._signaturePad.set('canvasHeight', this.signaturePadHeight);
        }
    }

    //TODO we could use SVG format once this ticket is resolved: https://github.com/wulfsolter/angular2-signaturepad/issues/30
    save() { this.modal.close(!this._signaturePad.isEmpty() ? this._signaturePad.toDataURL('image/png', 0.9) : undefined); }

    edit() { this.display = State.EDIT; }

    cancelEdit() { this.display = State.VIEW; }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/signature/signature-modal.component.ts